import BaseComponent from '@utils/base.js';
import tag from '@utils/utilTags.js';

import * as styles from './topHint.module.scss';

import { traverseFromTop } from '@utils/traverseMatrices.js';

/** @extends {BaseComponent<HTMLDivElement>} */
export default class TopHint extends BaseComponent {
  /** @param {Props<HTMLDivElement> & Required<{classes: string[], nonogram: number[][], difficulty: string}>} props */
  constructor(props) {
    super({ classes: [styles.topHint, ...props.classes] });

    const hint = traverseFromTop(props.nonogram);

    const cellSizeClassPostfix =
      props.difficulty[0].toUpperCase() + props.difficulty.slice(1);

    hint.forEach((row) => {
      const rowTag = tag.div({ classes: [styles.row] });

      row.forEach((cell) => {
        const cellTag = tag.div({
          classes: [styles.cell, styles[`cell${cellSizeClassPostfix}`]],
        });

        if (cell !== 0) {
          cellTag.setText(cell.toString());
        }

        rowTag.appendSingle(cellTag);
      });
      this.appendSingle(rowTag);
    });
  }
}
